export default __webpack_public_path__ + "static/media/saintlywarrior.5319520b.png";